import DOMPurify from 'dompurify';

// Tags TinyMCE's minimal toolbar can produce (plus wrappers it emits)
const ALLOWED_TAGS = ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'span', 'div'];

// Legacy notes are plain text; anything saved by TinyMCE contains one of the
// tags below. Matching only those keeps tag-like words in legacy notes
// (e.g. "<angle>") from being misclassified and stripped as unknown HTML.
const HTML_NOTE_PATTERN = new RegExp(`</?(${ALLOWED_TAGS.join('|')})[\\s>/]`, 'i');
export const isHtmlNote = (note) => HTML_NOTE_PATTERN.test(note || '');

export const escapeHtml = (s) =>
  (s || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export const plainTextToHtml = (text) => escapeHtml(text).replace(/\n/g, '<br>');

export const noteToPlainText = (note) => {
  if (!note) return '';
  if (!isHtmlNote(note)) return note;
  return new DOMParser().parseFromString(note, 'text/html').body.textContent || '';
};

// TinyMCE stores underline as <span style="text-decoration: underline">, not
// <u>. The sanitizer strips all attributes, so rewrite those spans to <u>
// first — keeping ALLOWED_ATTR empty instead of letting style through.
const underlineSpansToU = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  for (const span of doc.body.querySelectorAll('span[style]')) {
    const decoration = `${span.style.textDecoration} ${span.style.textDecorationLine}`;
    if (/\bunderline\b/i.test(decoration)) {
      const u = doc.createElement('u');
      while (span.firstChild) u.appendChild(span.firstChild);
      span.replaceWith(u);
    }
  }
  return doc.body.innerHTML;
};

export const noteToSafeHtml = (note) => {
  if (!note) return '';
  if (!isHtmlNote(note)) return plainTextToHtml(note);
  return DOMPurify.sanitize(underlineSpansToU(note), { ALLOWED_TAGS, ALLOWED_ATTR: [] });
};

export const isVisuallyEmpty = (note) => noteToPlainText(note).trim().length === 0;
